import eventLogApiDefinition from './api/index.js'
import { eventLogAtomDefinition } from './atoms/index.js'
import eventLogModuleDefinition from './module/index.js'
import eventLogReportDefinition from './report/index.js'
import eventLogLifecyclePluginDefinition from './plugins/index.js'

const VERSION_HISTORY_EVENT = 'build_changed'

const eventLog = ({ versionHistoryEventName = VERSION_HISTORY_EVENT } = Object.create(null)) => ({
  id: 'eventLog',
  definitions: [
    {
      definition: eventLogAtomDefinition,
      storage: { namespace: 'eventLog' },
      aliases: [{ implementationId: 'unsafeStorage', interfaceId: 'storage' }],
    },
    {
      definition: eventLogModuleDefinition,
      config: { versionHistoryEventName },
    },
    { definition: eventLogApiDefinition },
    { definition: eventLogReportDefinition },
    { definition: eventLogLifecyclePluginDefinition, config: { versionHistoryEventName } },
  ],
})

export default eventLog
